/**
 * Sprint E — mobile sticky buy bar on product pages.
 * Shows when the main purchase block scrolls off-screen; mirrors price/variant/ATC state.
 */
(function () {
  var MOBILE_MAX = 798;

  function isMobile() {
    return window.matchMedia('(max-width: ' + MOBILE_MAX + 'px)').matches;
  }

  function getProductSection() {
    return document.querySelector('.js-product_section');
  }

  function getStickyBar() {
    return document.querySelector('[data-lb-mobile-buy-bar]');
  }

  function getPurchaseBlock(section) {
    return section && section.querySelector('.purchase-details');
  }

  function getMainAtc(section) {
    return section && section.querySelector('[data-add-to-cart-trigger]');
  }

  function getPriceText(section) {
    if (!section) return '';
    var priceUi = section.querySelector('[data-price-ui]');
    if (!priceUi) return '';

    var priceNode =
      priceUi.querySelector('.price-ui__price') ||
      priceUi.querySelector('.money') ||
      priceUi.querySelector('[class*="price"]');

    if (priceNode) {
      return priceNode.textContent.replace(/\s+/g, ' ').trim();
    }

    return priceUi.textContent.replace(/\s+/g, ' ').trim();
  }

  function getVariantText(section) {
    if (!section) return '';

    var labels = [];
    section.querySelectorAll('.vsk-swatch-item.vsk--selected').forEach(function (el) {
      var label =
        el.getAttribute('aria-label') ||
        el.getAttribute('title') ||
        el.getAttribute('data-value') ||
        el.textContent;
      if (label) labels.push(label.trim());
    });

    if (labels.length) {
      return labels.join(' · ');
    }

    var select = section.querySelector('select[data-variants]');
    if (select && select.selectedIndex >= 0 && select.value !== 'not-selected') {
      var optionText = select.options[select.selectedIndex].textContent.trim();
      return optionText.replace(/\s*-\s*[\$£€].*$/, '').trim();
    }

    var checked = section.querySelector('.variant-selection input[type="radio"]:checked');
    if (checked && checked.value) {
      var radioLabel = section.querySelector('label[for="' + checked.id + '"]');
      if (radioLabel) return radioLabel.textContent.trim();
    }

    return '';
  }

  function syncStickyBar(section, bar) {
    var priceEl = bar.querySelector('[data-lb-sticky-price]');
    var variantEl = bar.querySelector('[data-lb-sticky-variant]');
    var stickyAtc = bar.querySelector('[data-lb-sticky-atc]');
    var mainAtc = getMainAtc(section);

    var priceText = getPriceText(section);
    if (priceText && priceEl) {
      priceEl.textContent = priceText;
    }

    var variantText = getVariantText(section);
    if (variantText && variantEl) {
      variantEl.textContent = variantText;
    }

    if (stickyAtc && mainAtc) {
      var disabled = mainAtc.disabled || mainAtc.classList.contains('disabled');
      stickyAtc.disabled = disabled;
      stickyAtc.classList.toggle('disabled', disabled);
      var labelSpan = mainAtc.querySelector('.text');
      if (labelSpan && labelSpan.textContent.trim()) {
        stickyAtc.textContent = labelSpan.textContent.trim();
      }
    }
  }

  function setBarVisible(bar, visible) {
    if (!bar) return;
    bar.hidden = !visible;
    bar.setAttribute('aria-hidden', visible ? 'false' : 'true');
    document.body.classList.toggle('lb-mobile-buy-bar--visible', visible);
  }

  function init() {
    if (!isMobile()) return;

    var section = getProductSection();
    var bar = getStickyBar();
    var purchase = getPurchaseBlock(section);

    if (!section || !bar || !purchase) return;

    var stickyAtc = bar.querySelector('[data-lb-sticky-atc]');
    if (stickyAtc) {
      stickyAtc.addEventListener('click', function () {
        var mainAtc = getMainAtc(section);
        if (mainAtc && !mainAtc.disabled) {
          mainAtc.click();
        }
      });
    }

    syncStickyBar(section, bar);

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          setBarVisible(bar, !entry.isIntersecting);
        });
      },
      { root: null, threshold: 0, rootMargin: '0px 0px -8px 0px' }
    );

    observer.observe(purchase);

    var syncTarget = section.querySelector('[data-product-form]') || section;
    var syncObserver = new MutationObserver(function () {
      syncStickyBar(section, bar);
    });

    syncObserver.observe(syncTarget, {
      subtree: true,
      childList: true,
      characterData: true,
      attributes: true,
      attributeFilter: ['class', 'disabled', 'aria-label', 'title']
    });

    section.addEventListener('change', function () {
      syncStickyBar(section, bar);
    });
    section.addEventListener('click', function (e) {
      if (e.target.closest('.vsk-swatch-item, [data-variant-option], .variant-selection')) {
        setTimeout(function () {
          syncStickyBar(section, bar);
        }, 50);
      }
    });

    window.addEventListener('resize', function () {
      if (!isMobile()) {
        setBarVisible(bar, false);
        observer.disconnect();
        syncObserver.disconnect();
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
